import { ExternalLink } from "lucide-react";
import Link from "next/link";

import { Button } from "~/components/ui/button";
import { type FragmentOf, type SiteLocale, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function CtaButton(props: {
  record: FragmentOf<typeof fragment.CtaButtonFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.CtaButtonFragment, props.record);

  const getButtonUrl = () => {
    if (record.externalUrl) {
      return record.externalUrl;
    }
    if (record.internalUrl) {
      return record.internalUrl;
    }
    return "#";
  };

  const isExternal = !!record.externalUrl;
  const url = getButtonUrl();
  const label = record.label || "Learn More";

  let link = <Link href={url}>{label}</Link>;
  if (isExternal) {
    link = (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2"
      >
        <ExternalLink className="h-4 w-4" />
        {label}
      </a>
    );
  }

  return (
    <div className="mt-10 flex justify-center">
      <Button
        asChild
        size="lg"
        className="bg-landing-900 hover:bg-landing-500 rounded-full px-6 py-3 font-normal text-white transition-colors duration-300"
      >
        {link}
      </Button>
    </div>
  );
}
